import React from 'react'

interface NumericButtonProps {
  text: string
  onPress: () => void
  isDelete?: boolean
  disabled?: boolean
  className?: string
}

const NumericButton: React.FC<NumericButtonProps> = ({ 
  text, 
  onPress, 
  isDelete = false,
  disabled = false,
  className = ''
}) => {
  const baseClasses = "flex items-center justify-center transition-all duration-200 focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed"
  
  const deleteClasses = `${baseClasses} bg-white text-black hover:bg-gray-50 active:bg-gray-100 h-[clamp(55px,6.5vw,78px)] rounded-[clamp(12px,1.5vw,18px)]  w-full`
  
  const numericClasses = `${baseClasses} bg-white text-black font-medium hover:bg-gray-50 active:bg-gray-100 h-[80px] rounded-[16px] text-[clamp(18px,2.2vw,24px)] font-['IBM Plex Sans Arabic'] font-medium w-full`

  return (
    <button
      className={`${isDelete ? deleteClasses : numericClasses} ${className}`}
      onClick={onPress}
      disabled={disabled}
      style={{ direction: 'ltr' }}
    >
      {isDelete ? (
        <svg className="w-[clamp(20px,2.5vw,24px])] h-[clamp(20px,2.5vw,24px)]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2M3 12l6.414 6.414a2 2 0 001.414.586H19a2 2 0 002-2V7a2 2 0 00-2-2h-8.172a2 2 0 00-1.414.586L3 12z" />
        </svg>
      ) : (
        <span>{text}</span>
      )}
    </button>
  )
}

export default NumericButton
